import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "1 2 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.381 12.873a1.967 1.967 0 0 0 1.73-1.018L20.65 5.44a.985.985 0 0 0-.86-1.463H5.161L4.232 2H1v1.977h1.977l3.558 7.5L5.2 13.891a1.98 1.98 0 0 0 1.73 2.936h11.861v-1.978H6.93l1.087-1.977ZM6.1 5.954h12.009L15.381 10.9H8.443Zm.83 11.861a1.977 1.977 0 1 0 1.977 1.977 1.974 1.974 0 0 0-1.977-1.977Zm9.884 0a1.977 1.977 0 1 0 1.977 1.977 1.974 1.974 0 0 0-1.976-1.977Z"
    }, null, -1)
  ])))
}
export default { render: render }